module.exports = __webpack_public_path__ + "aa83500823f9a73a7f2e65ba10a44f24.footer.jpg";


//////////////////
// WEBPACK FOOTER
// ./components/footer/assets/footer.jpg
// module id = CQT1
// module chunks = 0